/* @flow */

import exibirErro from '../../utils/exibir-erro';
import getElementoPorId from '../../utils/get-elemento-por-id';
import { cadastrarPackages, getDadosFormularioPackages } from '../eventos-formularios/packages';

const cadastroPackages = (empresasId: number, esconderEditar: Function) => {
    const form = getElementoPorId('formulario-packages');
    form.onsubmit = async (e) => {
        e.preventDefault();
        try {
            await cadastrarPackages(empresasId, getDadosFormularioPackages());
            esconderEditar();
        } catch (err) {
            exibirErro(err);
        }
    };
};

export default cadastroPackages;
